import classes from "../classes";
import React from "react";

export default class Alert extends React.PureComponent {
  constructor(props) {
    super(props);
    this.placeholder = React.createRef();
    this.notification = React.createRef();
  }

  componentDidUpdate() {
    var height = this.notification.current.offsetHeight;
    this.placeholder.current.style.height = `${height}px`;
  }

  render() {
    var { children, icon, onDismiss, subtle, title, type, fixed } = this.props;

    var dismiss;
    if (typeof onDismiss === "function") {
      dismiss = (
        <a className="notification_dismiss" href="#" onClick={onDismiss}>
          <span className="dw-close" />
        </a>
      );
    }
    var titleElem;
    if (title) {
      titleElem = (
        <h2 className="notification_title">
          {title}
        </h2>
      );
    }
    return (
      <div
        className={classes({
          "notification_placeholder": fixed
        })}
        ref={this.placeholder}>
        <div
          className={classes({
            "notification": true,
            [type]: true,
            "notification--subtle": subtle,
            "notification--is-visible": true,
            "notification--is-fixed": fixed
          })}
          ref={this.notification}>
          <div className="notification_content">
            <div className="notification_icon">
              <i className={icon} />
            </div>

            {dismiss}

            <div className="notification_body">
              {titleElem}

              {children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
